import { SocketStatus } from "@services/http/socket/WmSocket"
import { ActionSocketUpdateStatus } from "./actions"
import { ActionSocket } from "./actionTypes"

interface SocketStore {
  status: SocketStatus
}

const initialState: SocketStore = {
  status: SocketStatus.OFF
}

const socket = (state = initialState, action: ActionSocketUpdateStatus) => {
  switch (action.type) {
    case ActionSocket.UpdateStatus:
      return {
        ...state,
        status: action.payload
      }
    default:
      return state;
  }
}

export default socket;